/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/experiment.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ApiExperimentStorageState = {
  STORAGESTATE_UNSPECIFIED: 'STORAGESTATE_UNSPECIFIED',
  STORAGESTATE_AVAILABLE: 'STORAGESTATE_AVAILABLE',
  STORAGESTATE_ARCHIVED: 'STORAGESTATE_ARCHIVED',
} as const;
export type ApiExperimentStorageState =
  (typeof ApiExperimentStorageState)[keyof typeof ApiExperimentStorageState];

export function instanceOfApiExperimentStorageState(value: any): boolean {
  for (const key in ApiExperimentStorageState) {
    if (Object.prototype.hasOwnProperty.call(ApiExperimentStorageState, key)) {
      if (ApiExperimentStorageState[key as keyof typeof ApiExperimentStorageState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ApiExperimentStorageStateFromJSON(json: any): ApiExperimentStorageState {
  return ApiExperimentStorageStateFromJSONTyped(json, false);
}

export function ApiExperimentStorageStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiExperimentStorageState {
  return json as ApiExperimentStorageState;
}

export function ApiExperimentStorageStateToJSON(value?: ApiExperimentStorageState | null): any {
  return value as any;
}

export function ApiExperimentStorageStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ApiExperimentStorageState {
  return value as ApiExperimentStorageState;
}
